<template>
    <div>
        <div v-if="!cookiesAllowed" class="cookie-container is-hidden-touch">
            <div class="bg-blue-600 text-white rounded shadow-lg" style="background-color: #F8F9FA; width: 600px; margin: 0 auto; border: 1px solid #dcdde1; padding: 10px 20px; border-radius: 4px; z-index: 2147483639">
                <div class="js-cookie-consent cookie-consent py-2 px-4 shadow-lg">

                    <span style="display: inline-block: float: left; color: #7f8fa6; font-size: 14px;">
                        <!-- Weap.io uses cookies to give you the best possible experience. By continuing to visit or use our services, you agree to the use of cookies as described in our <router-link class="text-sky-600" :to="{ name: 'cookie' }">Cookie Policy</router-link>. -->
                        Your experience on this site will be improved by allowing <router-link class="text-sky-600" :to="{ name: 'cookie' }">cookies</router-link>.
                    </span>

                    <span @click="acceptAllowance" style="display: inline-block; float: right; cursor: pointer">
                        <font-awesome-icon :icon="['far', 'times-circle']"></font-awesome-icon>
                    </span>
                </div>
            </div>
        </div>
        <!-- <div v-if="!cookiesAllowed" class="cookie-container-mobile is-hidden-desktop">
            <div class="bg-blue-600 text-white rounded shadow-lg" style="background-color: #F8F9FA; width: 600px; margin: 0 auto; border: 1px solid #dcdde1; padding: 10px 20px; border-radius: 4px; z-index: 2147483639">
                <div class="js-cookie-consent cookie-consent py-2 px-4 shadow-lg">

                    <span style="display: inline-block: float: left; color: #7f8fa6; font-size: 14px;">
                        Your experience on this site will be improved by allowing <router-link class="text-sky-600" :to="{ name: 'cookie' }">cookies</router-link>.
                    </span>

                    <span @click="acceptAllowance" style="display: inline-block; float: right; cursor: pointer">
                        <font-awesome-icon :icon="['far', 'times-circle']"></font-awesome-icon>
                    </span>
                </div>
            </div>
        </div> -->
    </div>
</template>

<style>
.cookie-container-mobile {
    position:fixed;
    background-color: red;
    bottom: 20px;
    width: 100%;
    z-index: 2147483639;
}

.cookie-container {
    position:fixed;
    bottom: 20px;
    width: 100%;
    z-index: 2147483639;
}
</style>

<script>
export default {
    mounted() {
        if (!this.allowanceAccepted) {
            this.cookiesAllowed = false;
        }
    },

    data() {
        return {
            cookiesAllowed: true,
        }
    },

    methods: {
        acceptAllowance() {
            localStorage.cookiesAllowed = true;
            this.cookiesAllowed = true;
        },
    },

    computed: {
        allowanceAccepted() {
            let cookiesAllowed = localStorage.cookiesAllowed;
            return cookiesAllowed == 'true';
        },
    },
}
</script>
